import { render, staticRenderFns } from "./CreateStockTakingView.vue?vue&type=template&id=745ff14a&scoped=true&"
import script from "./CreateStockTakingView.vue?vue&type=script&lang=ts&"
export * from "./CreateStockTakingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ff14a",
  null
  
)

export default component.exports